// Shared ids for the 3D buildings layer (see rana-3dbag-3d-tiles.tsx). Kept in their own,
// dependency-free module so other layers can anchor to `BUILDING_LAYER_ID` via
// `beforeId={BUILDING_LAYER_ID}` without pulling in the (heavy) 3D tiles renderer.
export const BEFORE_BUILDING_LAYER_ID = "before-building-3d";
export const BUILDING_LAYER_ID = "building-3d";
